import React from 'react';
import PropTypes from 'prop-types';

export const Card = ({ fontColor, backgroundColor, heading, number, percentage, onClick }) => {



  return (
    <div className={`card border-0 h-100 text-${fontColor} card-bg-${backgroundColor}`} onClick={onClick}>
      <div className="card-body">
        <h5 className="card-title" dangerouslySetInnerHTML={{__html: heading.replace(' ', '<br/>')}}></h5>
        <h1>{number}</h1>
        <p className="card-text">{percentage}</p>
      </div>
    </div>
  );
};

Card.propTypes = {
  fontColor: PropTypes.oneOf(['white', 'dark']),
  backgroundColor: PropTypes.oneOf(['blue', 'lightblue', 'bluegreen', 'purple']),
  onClick: PropTypes.func,
  heading: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
  percentage: PropTypes.string.isRequired,
};

Card.defaultProps = {
    fontColor: 'white',
    backgroundColor: 'primary',
    onClick: () => {},
    heading: 'Card Heading',
    number: 10000,
    percentage: '100%',
};